<template>
   <div>
        <div class="table-wrapper on-991" v-if="$i18n.locale=='en'">
            <div>
                <table>
                    <thead>
                        <tr class="dark-gray">
                            <td class="white bold">Subsidiary</td>
                            <td class="end white bold b-right">Country of
                                <br />incorporation</td>
                            <td class="end white bold" colspan="2">Percentage of
                                <br />ownership</td>
                        </tr>
                        <tr class="med-gray">
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="skyBlue bolder end font ligest-gray">2020</td>
                            <td class="white bolder end font">2019</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class=" font-weight-bold font">Zain International B.V. (“ZIBV”)</td>
                            <td class="end font font-weight-bold font">The Netherlands</td>
                            <td class="end font ligest-gray font-weight-bold font">100%</td>
                            <td class="end font font-weight-bold font">100%</td>
                        </tr>
                        <tr>
                            <td class=" font-weight-bold font">Pella Investment Company (“Pella”)</td>
                            <td class="end font font-weight-bold font">Jordan</td>
                            <td class="end font ligest-gray font-weight-bold font">96.516%</td>
                            <td class="end font font-weight-bold font">96.516%</td>
                        </tr>
                        <tr>
                            <td class=" font-weight-bold font">Zain Bahrain B.S.C (“MTCB”)</td>
                            <td class="end font font-weight-bold font">Bahrain</td>
                            <td class="end font ligest-gray font-weight-bold font">55.40%</td>
                            <td class="end font font-weight-bold font">55.40%</td>
                        </tr>
                        <tr>
                            <td class=" font-weight-bold font">Mobile Telecommunications Company Lebanon (“MTCL”)</td>
                            <td class="end font font-weight-bold font">Lebanon</td>
                            <td class="end font ligest-gray font-weight-bold font">100%</td>
                            <td class="end font font-weight-bold font">100%</td>
                        </tr>
                        <tr>
                            <td class=" font-weight-bold font">Sudanese Mobile Telephone (Zain) Company Limited (“Zain Sudan”)</td>
                            <td class="end font font-weight-bold font">Sudan</td>
                            <td class="end font ligest-gray font-weight-bold font">100%</td>
                            <td class="end font font-weight-bold font">100%</td>
                        </tr>
                        <tr>
                            <td class=" font-weight-bold font">Kuwaiti Sudanese Holding Company (“KSHC”) </td>
                            <td class="end font font-weight-bold font">Sudan</td>
                            <td class="end font ligest-gray font-weight-bold font">100%</td>
                            <td class="end font font-weight-bold font">100%</td>
                        </tr>
                        <tr>
                            <td class=" font-weight-bold font">South Sudanese Mobile Telephone (“Zain South Sudan”) </td>
                            <td class="end font font-weight-bold font">South Sudan </td>
                            <td class="end font ligest-gray font-weight-bold font">100%</td>
                            <td class="end font font-weight-bold font">100%</td>
                        </tr>
                        <tr>
                            <td class=" font-weight-bold font">Al Khatem Telecoms Company (“Al Khatem”)</td>
                            <td class="end font font-weight-bold font">Iraq</td>
                            <td class="end font ligest-gray font-weight-bold font">76%</td>
                            <td class="end font font-weight-bold font">76%</td>
                        </tr>
                        <tr>
                            <td class=" font-weight-bold font">Atheer Telecom Iraq Limited (“Atheer”)</td>
                            <td class="end font font-weight-bold font">Cayman Islands</td>
                            <td class="end font ligest-gray font-weight-bold font">76%</td>
                            <td class="end font font-weight-bold font">76%</td>
                        </tr>
                        <tr>
                            <td class=" font-weight-bold font">Mobile Telecommunications Company (“SMTC”)</td>
                            <td class="end font font-weight-bold font">Kingdom of Saudi Arabia</td>
                            <td class="end font ligest-gray font-weight-bold font">37.045%</td>
                            <td class="end font font-weight-bold font">37.045%</td>
                        </tr>
                        <tr>
                            <td class=" font-weight-bold font">Al Mouakhaa Lil Kadamat Al-Logistya Wal Al-Itisalat (“Mada Jordan”) </td>
                            <td class="end font font-weight-bold font">Jordan</td>
                            <td class="end font ligest-gray font-weight-bold font">99.1%</td>
                            <td class="end font font-weight-bold font">99.1%</td>
                        </tr>
                        <tr>
                            <td class=" font-weight-bold font">Nexgen Advisory Group FZ LLC (“Nexgen”)</td>
                            <td class="end font font-weight-bold font">UAE</td>
                            <td class="end font ligest-gray font-weight-bold font">86.7%</td>
                            <td class="end font font-weight-bold font">86.7%</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <!-- Arabic -->

        <div class="table-wrapper on-991" v-if="$i18n.locale=='ar'">
            <div>
                <table>
                    <thead>
                        <tr class="dark-gray">
                            <td class="white bold">الشركات التابعة</td>
                            <td class="end white bold b-right">بلد التأسيس</td>
                            <td class="end white bold" colspan="2">نسبة الملكية</td>
                        </tr>
                        <tr class="med-gray">
                            <td><span class="invisible">asdf</span></td>
                            <td><span class="invisible">asdf</span></td>
                            <td class="skyBlue bolder end font ligest-gray">2020</td>
                            <td class="white bolder end font">2019</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class=" font-weight-bold font">شركة زين الدولية بي في "زين الدولية"</td>
                            <td class="end font font-weight-bold font">هولندا</td>
                            <td class="end font ligest-gray font-weight-bold font">%100</td>
                            <td class="end font font-weight-bold font">%100</td>
                        </tr>
                        <tr>
                            <td class=" font-weight-bold font">شركة بيلا للاستثمار – "بيلا"</td>
                            <td class="end font font-weight-bold font">الأردن</td>
                            <td class="end font ligest-gray font-weight-bold font">%96.516</td>
                            <td class="end font font-weight-bold font">%96.516</td>
                        </tr>
                        <tr>
                            <td class=" font-weight-bold font">شركة زين البحرين ش.م.ب. "زين البحرين"</td>
                            <td class="end font font-weight-bold font">البحرين</td>
                            <td class="end font ligest-gray font-weight-bold font">%55.40</td>
                            <td class="end font font-weight-bold font">%55.40</td>
                        </tr>
                        <tr>
                            <td class=" font-weight-bold font">شركة الاتصالات المتنقلة – لبنان ش.م.م. "زين لبنان"</td>
                            <td class="end font font-weight-bold font">لبنان</td>
                            <td class="end font ligest-gray font-weight-bold font">%100</td>
                            <td class="end font font-weight-bold font">%100</td>
                        </tr>
                        <tr>
                            <td class=" font-weight-bold font">الشركة السودانية للهاتف السيار المحدودة "زين السودان"</td>
                            <td class="end font font-weight-bold font">السودان</td>
                            <td class="end font ligest-gray font-weight-bold font">%100</td>
                            <td class="end font font-weight-bold font">%100</td>
                        </tr>
                        <tr>
                            <td class=" font-weight-bold font">الشركة الكويتية السودانية القابضة</td>
                            <td class="end font font-weight-bold font">السودان</td>
                            <td class="end font ligest-gray font-weight-bold font">%100</td>
                            <td class="end font font-weight-bold font">%100</td>
                        </tr>
                        <tr>
                            <td class=" font-weight-bold font">الشركة السودانية للهاتف السيار المحدودة "زين جنوب السودان"</td>
                            <td class="end font font-weight-bold font">جنوب السودان</td>
                            <td class="end font ligest-gray font-weight-bold font">%100</td>
                            <td class="end font font-weight-bold font">%100</td>
                        </tr>
                        <tr>
                            <td class=" font-weight-bold font">شركة الخاتم للاتصالات – "الخاتم"</td>
                            <td class="end font font-weight-bold font">العراق</td>
                            <td class="end font ligest-gray font-weight-bold font">%76</td>
                            <td class="end font font-weight-bold font">%76</td>
                        </tr>
                        <tr>
                            <td class=" font-weight-bold font">شركة أثير للاتصالات العراق المحدودة – "أثير"</td>
                            <td class="end font font-weight-bold font">جزر الكايمان</td>
                            <td class="end font ligest-gray font-weight-bold font">%76</td>
                            <td class="end font font-weight-bold font">%76</td>
                        </tr>
                        <tr>
                            <td class=" font-weight-bold font">شركة الاتصالات المتنقلة السعودية "زين السعودية"</td>
                            <td class="end font font-weight-bold font">السعودية</td>
                            <td class="end font ligest-gray font-weight-bold font">%37.045</td>
                            <td class="end font font-weight-bold font">%37.045</td>
                        </tr>
                        <tr>
                            <td class=" font-weight-bold font">شركة المؤاخاة للخدمات اللوجستية والاتصالات ( مدى الأردن)</td>
                            <td class="end font font-weight-bold font">الأردن</td>
                            <td class="end font ligest-gray font-weight-bold font">%99.1</td>
                            <td class="end font font-weight-bold font">%99.1</td>
                        </tr>
                        <tr>
                            <td class=" font-weight-bold font">مجموعة نكستجن للاستشارات، المنطقة الحرة ذ.م.م</td>
                            <td class="end font font-weight-bold font">الإمارات</td>
                            <td class="end font ligest-gray font-weight-bold font">%86.7</td>
                            <td class="end font font-weight-bold font">%86.7</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
   </div>
</template>

<script>
export default {

}
</script>

<style>

</style>